import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { AppService } from '@app/@core/services/app.service';
import { PagesService } from './@core/pages.service';
import  html2canvas from 'html2canvas' ;
import { DataStoreService } from '@app/@core/services/data-store.service';
import { supportIntegrationService } from '@app/@core/services/support-integration.service';
import { LocalService } from '@core/services/local.service';
import { AppConstants } from '@app/@core/entities/app-constants';
@Component({
  standalone: false,
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnDestroy {
  RBACORG: any;
  PERMISSION: any;
  submenuToggle: boolean = true;
  logoConfiguration: any;
  orgSubs: Subscription;
  headerEvent: BehaviorSubject<any>;
  constructor(
    private permissionStore: PermissionStore,
    private authService: AuthService,
    private httpService: HttpService,
    private appService: AppService,
    private PagesService: PagesService,
    private dataStoreService:DataStoreService,
    private supportIntegrationService:supportIntegrationService,
    private sessionStorage: LocalService

  ) {
    console.log('PAGE_HEADER');
    this.headerEvent = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment
      };
      this.headerEvent.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION,
        HTTPSERVICE: this.httpService,
        AUTHSERVICE: this.authService,
        APPSERVICE: this.appService,
        PAGESSERVICE: this.PagesService,
        DATASTORESERVICE:this.dataStoreService,
        SUPPORTSERVICE:this.supportIntegrationService
      });
    });
    this.logoConfiguration = {
      headerLogoPath: AppConstants.headerLogoPath,
      minimizedHeaderLogoPath: AppConstants.minimizedHeaderLogoPath
    }
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
